module.exports = __webpack_public_path__ + "img/roboto-v27-latin-ext_latin-900.117624e.svg";